// "/governance" should show the full interactive community governance experience directly.
// We reuse the main app page instead of duplicating logic.
import React from 'react';
import GovernanceCommunityPage from '../../../src/pages/entities/community_sub-elects/GovernanceCommunityPage';

export default function GovernanceIndex() {
  // Outer demo layout already has a header; suppress internal one to avoid stacking
  return <GovernanceCommunityPage disableInternalHeader topOffsetPx={120} />;
}
